import { Component } from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent {
  year=new Date().getFullYear();
  leftLogo:string="/assets/icons/EFX_logo_light.svg"
  rightLogo:string="/assets/icons/tagline-english-white.svg"
}
